import React from 'react';
import { FaServer } from 'react-icons/fa';
import { MdOutlineGeneratingTokens, MdOutlinePending, MdDone } from 'react-icons/md';
import RequestStatsDashboard from 'components/app/account-management/shared/RequestStatsDashboard';
import { getRequestTerminalAccounts } from 'redux/request/terminalAccountSlice';

const STATUS_CARDS = [
  { key: 'total',   label: 'Total Requests', icon: MdOutlineGeneratingTokens, from: '#667eea', to: '#764ba2' },
  { key: 'pending', label: 'Pending',        icon: MdOutlinePending,          from: '#f093fb', to: '#f5576c' },
  { key: 'closed',  label: 'Closed',         icon: MdDone,                    from: '#4facfe', to: '#00f2fe' },
];

const RequestTerminalAccount = () => (
  <RequestStatsDashboard
    title="Terminal Account Requests"
    subtitle="Manage and track all terminal account requests"
    Icon={FaServer}
    accent="#667eea"
    thunk={getRequestTerminalAccounts}
    statusCards={STATUS_CARDS}
    categoryTitle="Top Departments"
    categorySubtitle="Requests by department"
  />
);

export default RequestTerminalAccount;
